export default "__VITE_ASSET__DOP34AM___"